export default __webpack_public_path__ + "264ae74.png";